"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ReactTimeSeries = exports.ReactTimeSeriesWithoutContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _seamlessImmutable = require("seamless-immutable");

var _useEventCallback = _interopRequireDefault(require("use-event-callback"));

var _useAsyncMemo = require("use-async-memo");

var _recoil = require("recoil");

var _useGetRandomColorUsingHash = _interopRequireDefault(require("../../hooks/use-get-random-color-using-hash"));

var _reactMeasure = _interopRequireDefault(require("react-measure"));

var _useTimeCursorTime = require("../../hooks/use-time-cursor-time");

var _useRootAudioElm3 = _interopRequireDefault(require("../../hooks/use-root-audio-elm"));

var _MainLayout = _interopRequireDefault(require("../MainLayout"));

var _fetchAudioData = _interopRequireDefault(require("../../utils/fetch-audio-data"));

var _fetchCsvData = _interopRequireDefault(require("../../utils/fetch-csv-data"));

var _fixTimeData = _interopRequireDefault(require("../../utils/fix-time-data"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var emptyAr = []; // This is a cloudflare CORs proxy from the project maintainer @seveibar

var defaultCorsProxy = "https://corsproxy.seve.workers.dev/corsproxy/?apiurl={URL}";
var defaultEnabledTools = ["create-durations", "create-timestamps", "label-durations", "label-timestamps"];
var defaultGraphs = [{
  keyName: "value"
}];

var ReactTimeSeriesWithoutContext = function ReactTimeSeriesWithoutContext(_ref) {
  var _ref$corsProxy = _ref.corsProxy,
      corsProxy = _ref$corsProxy === void 0 ? defaultCorsProxy : _ref$corsProxy,
      iface = _ref.interface,
      sample = _ref.sample,
      widthProp = _ref.width,
      onModifySample = _ref.onModifySample;
  if (!iface) throw new Error("\"interface\" is a required prop");
  if (!sample) throw new Error("\"sample\" is a required prop");
  var getRandomColorUsingHash = (0, _useGetRandomColorUsingHash.default)();
  var timeFormat = iface.timeFormat,
      _iface$enabledTools = iface.enabledTools,
      enabledTools = _iface$enabledTools === void 0 ? defaultEnabledTools : _iface$enabledTools,
      _iface$durationLabels = iface.durationLabels,
      durationLabels = _iface$durationLabels === void 0 ? emptyAr : _iface$durationLabels,
      _iface$timestampLabel = iface.timestampLabels,
      timestampLabels = _iface$timestampLabel === void 0 ? emptyAr : _iface$timestampLabel,
      _iface$graphs = iface.graphs,
      graphs = _iface$graphs === void 0 ? defaultGraphs : _iface$graphs,
      allowCustomLabels = iface.allowCustomLabels,
      showValues = iface.showValues;
  var sampleTimeData = sample.timeData,
      audioUrl = sample.audioUrl,
      csvUrl = sample.csvUrl,
      annotation = sample.annotation;
  if (showValues === undefined && !audioUrl) showValues = true;
  var timeDataAvailable = [sampleTimeData, audioUrl, csvUrl].some(Boolean);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPlayingMedia = _useState2[0],
      setIsPlayingMedia = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var timeData = (0, _useAsyncMemo.useAsyncMemo)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!sampleTimeData) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", (0, _fixTimeData.default)(sampleTimeData, graphs));

          case 3:
            if (!audioUrl) {
              _context.next = 10;
              break;
            }

            _context.t0 = _fixTimeData.default;
            _context.next = 7;
            return (0, _fetchAudioData.default)(audioUrl);

          case 7:
            _context.t1 = _context.sent;
            _context.t2 = graphs;
            return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2));

          case 10:
            if (!csvUrl) {
              _context.next = 17;
              break;
            }

            _context.t3 = _fixTimeData.default;
            _context.next = 14;
            return (0, _fetchCsvData.default)(csvUrl);

          case 14:
            _context.t4 = _context.sent;
            _context.t5 = graphs;
            return _context.abrupt("return", (0, _context.t3)(_context.t4, _context.t5));

          case 17:
            throw new Error("No timeData, no audioUrl, no csvUrl, no time data provided.");

          case 20:
            _context.prev = 20;
            _context.t6 = _context["catch"](0);
            setError(_context.t6);
            return _context.abrupt("return", []);

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 20]]);
  })), [sampleTimeData, audioUrl, csvUrl], null);
  var timeDataLoading = !timeData && timeDataAvailable;
  var curveGroups = (0, _react.useMemo)(function () {
    if (!timeData) return [];
    var anonRows = [];
    var namedRows = {};

    var _iterator = _createForOfIteratorHelper(graphs),
        _step;

    try {
      var _loop = function _loop() {
        var graph = _step.value;
        var curveData = timeData.filter(function (a) {
          return a[graph.keyName] !== undefined && a[graph.keyName] !== null;
        }).map(function (a) {
          return [a.time, a[graph.keyName]];
        });

        if (graph.row === undefined || graph.row === null) {
          var curveGroup = [{
            data: curveData,
            color: graph.color || getRandomColorUsingHash(graph.keyName)
          }];
          anonRows.push(curveGroup);
        } else {
          if (!namedRows[graph.row]) {
            namedRows[graph.row] = [];
          }

          namedRows[graph.row].push({
            data: curveData,
            color: graph.color || getRandomColorUsingHash(graph.keyName)
          });
        }
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return anonRows.concat(Object.entries(namedRows).sort(function (a, b) {
      return a[0].localeCompare(b[0]);
    }));
  }, [timeData, graphs, getRandomColorUsingHash]);
  var timestamps = (0, _react.useMemo)(function () {
    if (!(annotation !== null && annotation !== void 0 && annotation.timestamps)) return [];
    return annotation === null || annotation === void 0 ? void 0 : annotation.timestamps.map(function (ts) {
      return {
        time: ts.time,
        label: ts.label,
        color: ts.color || getRandomColorUsingHash(ts.label)
      };
    }); // eslint-disable-next-line
  }, [annotation === null || annotation === void 0 ? void 0 : annotation.timestamps, getRandomColorUsingHash]);
  var durationGroups = (0, _react.useMemo)(function () {
    if (!(annotation !== null && annotation !== void 0 && annotation.durations)) return !enabledTools.includes("create-durations") ? [] : [{
      color: "#888888",
      misc: true,
      durations: []
    }];
    var availableLabels = Array.from(new Set(annotation.durations.flatMap(function (d) {
      return [d.label, d.layer];
    }).filter(Boolean)));
    availableLabels.sort(); // TODO no more than 5 layers, after 5 layers start reusing layers

    var durationGroups = availableLabels.map(function (label) {
      return {
        label: label,
        color: getRandomColorUsingHash(label),
        durations: annotation.durations.filter(function (d) {
          return d.label === label;
        }).map(function (d) {
          return {
            start: d.start,
            end: d.end,
            label: d.label
          };
        })
      };
    }).filter(function (dg) {
      return dg.durations.length > 0;
    });

    if (enabledTools.includes("create-durations")) {
      durationGroups.push({
        color: "#888888",
        misc: true,
        durations: durationGroups.filter(function (dg) {
          return dg.durations.length === 1;
        }).flatMap(function (dg) {
          return dg.durations;
        }).concat(annotation.durations.filter(function (d) {
          return !d.label;
        })).map(function (d) {
          return _objectSpread(_objectSpread({}, d), {}, {
            color: getRandomColorUsingHash(d.label)
          });
        })
      });
    }

    durationGroups = durationGroups.filter(function (dg) {
      return dg.misc || dg.durations.length > 1;
    });
    return durationGroups; // eslint-disable-next-line
  }, [annotation === null || annotation === void 0 ? void 0 : annotation.durations]);
  var onChangeDurationGroups = (0, _useEventCallback.default)(function (newDurationGroups) {
    onModifySample((0, _seamlessImmutable.setIn)(sample, ["annotation", "durations"], newDurationGroups.flatMap(function (dg) {
      return dg.durations.map(function (d) {
        return _objectSpread(_objectSpread({}, d.label && dg.label !== d.label ? {} : {
          label: dg.label
        }), d);
      });
    })));
  });
  var onChangeTimestamps = (0, _useEventCallback.default)(function (newTimestamps) {
    onModifySample((0, _seamlessImmutable.setIn)(sample, ["annotation", "timestamps"], newTimestamps));
  });

  var _useState5 = (0, _react.useState)(widthProp),
      _useState6 = _slicedToArray(_useState5, 2),
      width = _useState6[0],
      setWidth = _useState6[1];

  var onResize = (0, _useEventCallback.default)(function (_ref3) {
    var bounds = _ref3.bounds;
    if (!widthProp) setWidth(bounds.width);
  });
  var audioSource = (0, _react.useRef)();

  var _useRootAudioElm = (0, _useRootAudioElm3.default)(),
      _useRootAudioElm2 = _slicedToArray(_useRootAudioElm, 2),
      setRootAudioElm = _useRootAudioElm2[1];

  var setTimeCursorTime = (0, _useTimeCursorTime.useSetTimeCursorTime)();
  (0, _react.useEffect)(function () {
    if (audioUrl) {
      audioSource.current = new Audio(audioUrl);
      setTimeCursorTime(0);
    }
  }, []);
  var onAudioTimeChanged = (0, _useEventCallback.default)(function () {
    setTimeCursorTime(audioSource.current.currentTime * 1000);
  });
  var onAudioPaused = (0, _useEventCallback.default)(function () {
    audioSource.current.removeEventListener("timeupdate", onAudioTimeChanged);
    audioSource.current.removeEventListener("pause", onAudioPaused);
  });
  var onStartPlayback = (0, _useEventCallback.default)(function () {
    setIsPlayingMedia(true);

    if (audioSource.current) {
      audioSource.current.play();
      audioSource.current.addEventListener("timeupdate", onAudioTimeChanged);
      audioSource.current.addEventListener("pause", onAudioPaused);
      setRootAudioElm(audioSource.current);
    }
  });
  var onStopPlayback = (0, _useEventCallback.default)(function () {
    setIsPlayingMedia(false);

    if (audioSource.current) {
      audioSource.current.pause();
    }
  });
  if (timeDataLoading) return "loading"; // TODO real loader

  if (!timeData) {
    throw new Error("No time data provided. Try sample={{timeData: [{time: 0, value: 1}, ...]}} or sample={{audioUrl:\"https://...\"}}");
  }

  if (curveGroups.length === 0) {
    throw new Error("For some reason, no curves are able to be displayed.");
  }

  if (error) {
    throw error;
  }

  return /*#__PURE__*/_react.default.createElement(_reactMeasure.default, {
    bounds: true,
    onResize: onResize
  }, function (_ref4) {
    var measureRef = _ref4.measureRef;
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: measureRef
    }, /*#__PURE__*/_react.default.createElement(_MainLayout.default, {
      width: width,
      curveGroups: curveGroups,
      timeFormat: timeFormat,
      durationGroups: durationGroups,
      onChangeDurationGroups: onChangeDurationGroups,
      timestamps: timestamps,
      onChangeTimestamps: onChangeTimestamps,
      timestampLabels: timestampLabels,
      durationLabels: durationLabels,
      allowCustomLabels: allowCustomLabels,
      enabledTools: enabledTools,
      showValues: showValues,
      onStartPlayback: onStartPlayback,
      onStopPlayback: onStopPlayback,
      isPlayingMedia: isPlayingMedia
    }));
  });
};

exports.ReactTimeSeriesWithoutContext = ReactTimeSeriesWithoutContext;

var ReactTimeSeries = function ReactTimeSeries(props) {
  return /*#__PURE__*/_react.default.createElement(_recoil.RecoilRoot, null, /*#__PURE__*/_react.default.createElement(ReactTimeSeriesWithoutContext, props));
};

exports.ReactTimeSeries = ReactTimeSeries;
var _default = ReactTimeSeries;
exports.default = _default;